module.exports = __webpack_public_path__ + "static/media/calefont14.f581b745.png";